import { createApp } from "vue";
import App from "./App.vue";
import store from "./store/index";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import Notifications from '@kyvg/vue3-notification';
// import vuescroll from 'vuescroll';
import TranslatedTextComponent from '@/components/translations/TranslatedTextComponent.vue';
import '@/assets/icomoon-v1.0_kat/style.scss';

loadFonts();

createApp(App)
.component('translated-text-component', TranslatedTextComponent)
.use(store)
.use(vuetify)
.use(Notifications)
// .use(vuescroll as any)
.mount("#app");

